import { Link } from 'components/Atoms/Link'
import { RestrictedBannerCSS } from './RestrictedBannerCSS.styled'
import { useCountryAllowance } from './useCountryAllowance'

export const RestrictedBanner = () => {
  const { isAllowed } = useCountryAllowance()
  if (isAllowed) return null
  return (
    <div></div>
    // <RestrictedBannerCSS>
    //   <div id='ip_restricted_banner' className='banner-text'>
    //     Your IP is restricted.
    //     {/* <a href='/restricted' variant='underlined' rel='noopener noreferrer' target='_self'>
    //       these other countries
    //     </a> */}
    //     <Link to='/restricted'>See Countries.</Link>
    //   </div>
    //   {/* 
    //   <div id='ip_restricted_banner' className='banner-text'>
    //     Your IP is restricted. YOLOrekt is not available to US residents and other countries listed{' '}
    //     <Link to='/restricted'>here</Link>.
    //   </div> */}
    // </RestrictedBannerCSS>
  )
}
